import { Checkbox } from './src/form/Checkbox';
import { TextInput } from './src/form/TextInput';
import { Store } from './src/store/Store';
import { Select } from './src/form/select/Select';
import { Completion } from './src/form/Completion';
import { Modax } from './src/layout/Modax';
import { Dialog } from './src/layout/Dialog';
import { Button } from './src/display/Button';
import { FieldElement } from './src/form/FieldElement';
import { Loading } from './src/display/Loading';
import { CharCount } from './src/display/CharCount';
import { Options } from './src/display/Options';
import { ContactChat } from './src/live/ContactChat';
import { TicketList } from './src/list/TicketList';
import { ContactDetails } from './src/live/ContactDetails';
import { TembaList } from './src/list/TembaList';
import { ContactSearch } from './src/form/ContactSearch';
import { VectorIcon } from './src/display/Icon';
import { Alert } from './src/display/Alert';
import { Omnibox } from './src/form/select/Omnibox';
import { Tip } from './src/display/Tip';
import { TembaMenu } from './src/list/TembaMenu';
import { Anchor } from './src/display/Anchor';
import { Dropdown } from './src/display/Dropdown';
import { TabPane } from './src/layout/TabPane';
import { Tab } from './src/layout/Tab';
import Label from './src/display/Label';
import { ContactName } from './src/display/ContactName';
import { ContactUrn } from './src/display/ContactUrn';
import { ContactFields } from './src/live/ContactFields';
import { ContactFieldEditor } from './src/live/ContactFieldEditor';

import { ContactBadges } from './src/live/ContactBadges';
import { ContactPending } from './src/live/ContactPending';
import { TembaSlider } from './src/form/TembaSlider';
import { RunList } from './src/list/RunList';
import { FlowStoreElement } from './src/store/FlowStoreElement';
import { ContactNameFetch } from './src/live/ContactNameFetch';
import { DatePicker } from './src/form/DatePicker';
import { FieldManager } from './src/live/FieldManager';
import { SortableList } from './src/list/SortableList';
import { ContentMenu } from './src/list/ContentMenu';
import { TembaDate } from './src/display/TembaDate';
import { Compose } from './src/form/Compose';
import { Lightbox } from './src/display/Lightbox';
import { ColorPicker } from './src/form/ColorPicker';
import { Resizer } from './src/layout/Resizer';
import { Thumbnail } from './src/display/Thumbnail';
import { NotificationList } from './src/list/NotificationList';
import { WebChat } from './src/webchat/WebChat';
import { ImagePicker } from './src/form/ImagePicker';
import { Mask } from './src/layout/Mask';
import { TembaUser } from './src/display/TembaUser';
import { TemplateEditor } from './src/form/TemplateEditor';
import { Toast } from './src/display/Toast';
import { Chat } from './src/display/Chat';
import { MediaPicker } from './src/form/MediaPicker';
import { Editor } from './src/flow/Editor';
import { CanvasNode } from './src/flow/CanvasNode';
import { StickyNote } from './src/flow/StickyNote';
import { CanvasMenu } from './src/flow/CanvasMenu';
import { NodeTypeSelector } from './src/flow/NodeTypeSelector';
import { ContactNotepad } from './src/live/ContactNotepad';
import { ProgressBar } from './src/display/ProgressBar';
import { StartProgress } from './src/live/StartProgress';
import { ShortcutList } from './src/list/ShortcutList';
import { PopupSelect } from './src/form/select/PopupSelect';
import { UserSelect } from './src/form/select/UserSelect';
import { WorkspaceSelect } from './src/form/select/WorkspaceSelect';
import { TembaChart } from './src/live/TembaChart';
import { RangePicker } from './src/form/RangePicker';
import { NodeEditor } from './src/flow/NodeEditor';
import { KeyValueEditor } from './src/form/KeyValueEditor';
import { TembaArrayEditor } from './src/form/ArrayEditor';
import { MessageEditor } from './src/form/MessageEditor';
import './src/form/BaseListEditor'; // Import base class
import { FloatingTab } from './src/display/FloatingTab';
import { FloatingWindow } from './src/layout/FloatingWindow';

export function addCustomElement(name: string, comp: any) {
  if (!window.customElements.get(name)) {
    window.customElements.define(name, comp);
  }
}

addCustomElement('temba-anchor', Anchor);
addCustomElement('temba-alert', Alert);
addCustomElement('temba-store', Store);
addCustomElement('temba-textinput', TextInput);
addCustomElement('temba-datepicker', DatePicker);
addCustomElement('temba-range-picker', RangePicker);
addCustomElement('temba-date', TembaDate);
addCustomElement('temba-completion', Completion);
addCustomElement('temba-checkbox', Checkbox);
addCustomElement('temba-select', Select);
addCustomElement('temba-options', Options);
addCustomElement('temba-loading', Loading);
addCustomElement('temba-lightbox', Lightbox);
addCustomElement('temba-button', Button);
addCustomElement('temba-omnibox', Omnibox);
addCustomElement('temba-tip', Tip);
addCustomElement('temba-contact-name', ContactName);
addCustomElement('temba-contact-name-fetch', ContactNameFetch);
addCustomElement('temba-contact-field', ContactFieldEditor);
addCustomElement('temba-contact-fields', ContactFields);
addCustomElement('temba-field-manager', FieldManager);
addCustomElement('temba-urn', ContactUrn);
addCustomElement('temba-content-menu', ContentMenu);

// Note: FieldElement is a base class and not directly instantiated as a custom element
export { FieldElement };
addCustomElement('temba-dialog', Dialog);
addCustomElement('temba-modax', Modax);
addCustomElement('temba-charcount', CharCount);
addCustomElement('temba-contact-chat', ContactChat);
addCustomElement('temba-contact-details', ContactDetails);
addCustomElement('temba-ticket-list', TicketList);
addCustomElement('temba-notification-list', NotificationList);
addCustomElement('temba-list', TembaList);
addCustomElement('temba-sortable-list', SortableList);
addCustomElement('temba-run-list', RunList);
addCustomElement('temba-flow-details', FlowStoreElement);
addCustomElement('temba-label', Label);
addCustomElement('temba-menu', TembaMenu);
addCustomElement('temba-contact-search', ContactSearch);
addCustomElement('temba-icon', VectorIcon);
addCustomElement('temba-dropdown', Dropdown);
addCustomElement('temba-tabs', TabPane);
addCustomElement('temba-tab', Tab);
addCustomElement('temba-contact-badges', ContactBadges);
addCustomElement('temba-contact-pending', ContactPending);
addCustomElement('temba-slider', TembaSlider);
addCustomElement('temba-content-menu', ContentMenu);
addCustomElement('temba-compose', Compose);
addCustomElement('temba-color-picker', ColorPicker);
addCustomElement('temba-resizer', Resizer);
addCustomElement('temba-thumbnail', Thumbnail);
addCustomElement('temba-webchat', WebChat);
addCustomElement('temba-image-picker', ImagePicker);
addCustomElement('temba-mask', Mask);
addCustomElement('temba-user', TembaUser);
addCustomElement('temba-template-editor', TemplateEditor);
addCustomElement('temba-toast', Toast);
addCustomElement('temba-chat', Chat);
addCustomElement('temba-media-picker', MediaPicker);
addCustomElement('temba-flow-editor', Editor);
addCustomElement('temba-node-editor', NodeEditor);
addCustomElement('temba-flow-node', CanvasNode);
addCustomElement('temba-sticky-note', StickyNote);
addCustomElement('temba-canvas-menu', CanvasMenu);
addCustomElement('temba-node-type-selector', NodeTypeSelector);
addCustomElement('temba-contact-notepad', ContactNotepad);
addCustomElement('temba-progress', ProgressBar);
addCustomElement('temba-start-progress', StartProgress);
addCustomElement('temba-shortcuts', ShortcutList);
addCustomElement('temba-popup-select', PopupSelect);
addCustomElement('temba-user-select', UserSelect);
addCustomElement('temba-workspace-select', WorkspaceSelect);
addCustomElement('temba-chart', TembaChart);
addCustomElement('temba-key-value-editor', KeyValueEditor);
addCustomElement('temba-array-editor', TembaArrayEditor);
addCustomElement('temba-message-editor', MessageEditor);
addCustomElement('temba-floating-tab', FloatingTab);
addCustomElement('temba-floating-window', FloatingWindow);
